<template>
  <div class="szw-row szw-absolute szw-bottom-2 szw-gap-1" :style="{ width: `calc(100% - ${offset}px)`, marginLeft: `${offset && fullWidthButtons ? offset / 2 : 0}px`  }" :class="!fullWidthButtons ? 'szw-max-w-[768px]' : 'szw-max-w-[none]'">
    <button @click="handleUp" :class="[classes, isUpDisabledTab ? colorSchema.disable : colorSchema.active]" e2e-id="navigation-scroll-up">
      <sprite sprite-id="chevron-up" :color="isUpDisabledTab ? 'var(--szw-disable-dark)' : 'var(--szw-text-icon-secondary)'" />
    </button>
    <button @click="handleDown" :class="[classes, isDownDisabledTab ? colorSchema.disable : colorSchema.active]" e2e-id="navigation-scroll-down">
      <sprite sprite-id="chevron-down" :color="isDownDisabledTab ? 'var(--szw-disable-dark)' : 'var(--szw-text-icon-secondary)'" />
    </button>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue'
import Sprite from '../../sprite/Sprite.vue'

const emit = defineEmits(['nav-up', 'nav-down'])

const props = defineProps({
  isUpDisabledTab: {
    type: Boolean,
    default: false
  },
  isDownDisabledTab: {
    type: Boolean,
    default: false
  },
  fullWidthButtons: {
    type: Boolean,
    default: false
  },
  offset: {
    type: Number,
    default: 16
  }
})

const themeVersion = inject('themeVersion', 'current')

const classes = computed(() => `szw-row__center szw-text-white szw-flex-1 szw-h-10 szw-rounded`)

const colorSchema = computed(() => {
  if (themeVersion === 'latest') {
    return {
      active: 'szw-bg-latest-color-primary',
      disable: 'szw-bg-latest-disable-light'
    }
  }

  return {
    active: 'szw-bg-color-primary',
    disable: 'szw-bg-disable-light'
  }
})

const handleUp = () => {
  !props.isUpDisabledTab && emit('nav-up')
}
const handleDown = () => {
  !props.isDownDisabledTab && emit('nav-down')
}
</script>
